module.exports = __webpack_public_path__ + "img/AFES Mobile App Login BG with Logo.d869730e.jpg";